// src/components/AdminSubmissions.jsx
import React from 'react';

const AdminSubmissions = () => {
  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-800 mb-6">All Submissions</h2>
      <div className="bg-white rounded-lg shadow-sm p-8">
        <p className="text-gray-600">Submissions management coming soon...</p>
      </div>
    </div>
  );
};

export default AdminSubmissions;